import { Switch } from "@headlessui/react";

function SwitchToogle(props: {
  value: boolean;
  onChange: (checked: boolean) => void;
  text: string;
}) {
  return (
    <Switch.Group as="div" className="flex  items-center justify-between">
      <span className="text-sm font-medium text-gray-900 mr-2 ">
        {props.text}
      </span>

      <Switch
        checked={props.value}
        onChange={props.onChange}
        className={`${
          props.value ? "bg-purple-700" : "bg-gray-200"
        } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2`}
      >
        <span
          aria-hidden="true"
          className={`${
            props.value ? "translate-x-5" : "translate-x-0"
          } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </Switch.Group>
  );
}

export default SwitchToogle;
